import React, { useEffect, useState, useCallback } from 'react';
// import 'antd/dist/antd.css';
import { Table, Typography, message, Spin, Select, Button, Popconfirm } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import efn from './ConferencesFns.js'
import './Conferences.scss';
const { Text } = Typography;
function ConferenceFeatures(props) {
  const { conferenceSetting, conferencesMode } = props
  const [isActive, setIsActive] = useState(conferenceSetting.isActive)
  useEffect(() => {
    setIsActive(conferenceSetting.isActive)
  }, [conferenceSetting.isActive])
  const [isSaveLoading, setIsSaveLoading] = useState(false)
  let setFuncMap = { ...props.setFuncMap, setIsSaveLoading }
  return (
    <>
      <Popconfirm
        placement="left"
        title={`確認要封存: ${conferenceSetting.title}?`}
        onConfirm={() => { efn.archiveConferenceByUid(conferenceSetting, setFuncMap, conferencesMode) }}
        okText="Yes"
        cancelText="No"
      ><Button className="archive-btn"
        loading={conferenceSetting.archiveIsLoading}>封存</Button>
      </Popconfirm>
      <Popconfirm
        placement="left"
        title={`確認要複製 ${conferenceSetting.title}?`}
        onConfirm={() => { efn.copyConferenceByUid(conferenceSetting, setFuncMap, conferencesMode) }}
        okText="Yes"
        cancelText="No"
      ><Button className="copy-btn"
        loading={conferenceSetting.copyIsLoading}>複製</Button>
      </Popconfirm>
      <Select
        value={isActive}
        onChange={(e) => {
          setIsActive(e)
        }}
        style={{
          width: 120,
        }}
        options={[
          {
            value: 1,
            label: "啟用",
          },
          {
            value: 0,
            label: "停用",
          },
        ]}
      />
      {conferenceSetting.isActive != isActive && <Popconfirm
        placement="left"
        title={`確認要更新 ${conferenceSetting.title}?`}
        onConfirm={() => { efn.updateConferenceIsActiveByUid(conferenceSetting.uid, isActive, setFuncMap, conferencesMode) }}
        okText="Yes"
        cancelText="No"
      ><Button className="copy-btn" loading={isSaveLoading}>儲存</Button>
      </Popconfirm>}
    </>
  );
}



export default ConferenceFeatures;
